import * as Storage from './Storage';
export const Token = async () => {
  return await Storage.get('accessToken');
};
export const LoggedInUser = async () => {
  return await Storage.get('loggedInUser', true);
};